import { RootState } from 'src/store';

import { IMerchantAccount } from './types';

export const selectAccountsLoading = (state: RootState): boolean => state.accountsPayment.isLoading;
export const selectAccountsLoaded = (state: RootState): boolean => state.accountsPayment.isLoaded;
export const selectAccountDetails = (state: RootState): IMerchantAccount | null => state.accountsPayment.details;
